import React from 'react';
import WarningPanel from '@/components/warnings/WarningPanel';
import type { ResolvedWarning, WarningToken } from '@/shared/warnings/types';

interface SectionWarningsProps {
  warnings: ResolvedWarning[];
  onTokenClick: (token: WarningToken) => void;
  /** When true, transforms "council tax" to "council rates" for NI users */
  isNorthernIreland?: boolean;
}

const SectionWarnings: React.FC<SectionWarningsProps> = ({ warnings, onTokenClick, isNorthernIreland = false }) => {
  if (!Array.isArray(warnings) || warnings.length === 0) return null;
  return (
    <WarningPanel
      warnings={warnings}
      onTokenClick={onTokenClick}
      isNorthernIreland={isNorthernIreland}
    />
  );
};

export default SectionWarnings;


